// extracted by mini-css-extract-plugin
module.exports = {"main":"ChatItem_main_Krzes","box":"ChatItem_box_qB6Q4","right":"ChatItem_right_3m9jC","avatar":"ChatItem_avatar_3trKK","space":"ChatItem_space_QEhoN"};